import { render } from "./Driver.vue?vue&type=template&id=7ace2d1b&ts=true"
import script from "./Driver.vue?vue&type=script&lang=ts"
export * from "./Driver.vue?vue&type=script&lang=ts"

import "./Driver.vue?vue&type=style&index=0&id=7ace2d1b&lang=scss"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__